import React, { lazy, useEffect, useState } from "react";
import Login from "../src/pages/beforeAuth/login/Login";
import "./App.css";
import PhoneInput from "react-phone-input-2";
import "react-toastify/dist/ReactToastify.css";
import BatchesOverview from "./components/batch/batchesverview/BatchesOverview";
import LoginPvt from "./LoginPrivateRoute/LoginPvt";
const Batch = lazy(() => import("./pages/afterAuth/batch/batchSection/Batch"));
const CourseList = lazy(() => import("./pages/afterAuth/batch/CourseList"));
const AddBlog = lazy(() => import("./pages/afterAuth/blogMore/AddBlog"));
const Blog = lazy(() => import("./pages/afterAuth/blogMore/Blog"));
const MockTestOverView = lazy(() =>
  import("./pages/afterAuth/blogMore/mocktest/MockTestOverView")
);
const NewMockTest = lazy(() =>
  import("./pages/afterAuth/blogMore/mocktest/newmocktest/NewMockTest")
);
const Calender = lazy(() => import("./pages/afterAuth/calender/Calender"));
const AddCourses = lazy(() => import("./pages/afterAuth/courses/AddCourses"));
const AddCourseCategories = lazy(() =>
  import("./pages/afterAuth/courses/CourseCategories/AddCourseCategories")
);
const CourseCategories = lazy(() =>
  import("./pages/afterAuth/courses/CourseCategories/CourseCategories")
);
const Courses = lazy(() => import("./pages/afterAuth/courses/Courses"));
const EnrolledStudents = lazy(() =>
  import("./pages/afterAuth/courses/EnrolledStudents/EnrolledStudents")
);
import { Dashboard } from "./pages/afterAuth/dashboard/Dashboard";
import { Layout } from "./pages/afterAuth/layout/Layout";
const NotificationsPage = lazy(() =>
  import("./pages/afterAuth/notifications/NotificationsPage")
);
const Announcement = lazy(() =>
  import("./pages/afterAuth/queryAnnouncement/announcement/Announcement")
);

const Students = lazy(() =>
  import("./pages/afterAuth/userManagement/students/Students")
);
const ManagePermissions = lazy(() =>
  import("./pages/afterAuth/userManagement/subAdmin/ManagePermissions")
);
const SubAdmins = lazy(() =>
  import("./pages/afterAuth/userManagement/subAdmin/SubAdmins")
);
const TrainerForm = lazy(() =>
  import("./pages/afterAuth/userManagement/trainers/TrainerForm")
);
const Trainers = lazy(() =>
  import("./pages/afterAuth/userManagement/trainers/Trainers")
);
const AddWebinar = lazy(() =>
  import("./pages/afterAuth/webinar/AddWebinar/AddWebinar")
);
const Webinar = lazy(() => import("./pages/afterAuth/webinar/Webinar"));
import PaymentReport from "./pages/afterAuth/roiReports/PaymentReport";
import Roi from "./pages/afterAuth/roiReports/Roi";
import ForgotPassword from "./pages/beforeAuth/ForgotPassword/ForgotPassword";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import RouteContext from "./utils/context/RouteContext";
import AppRoutes from "./AppRoutes";
import { roles } from "./components/sidenav/constant";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const PreviewBlog = lazy(() =>
  import("./pages/afterAuth/blogMore/PreviewBlog")
);
const CompanyRole = lazy(() =>
  import("./pages/afterAuth/careers/companyRole/CompanyRole")
);
const TrainerRole = lazy(() =>
  import(".//pages/afterAuth/careers/trainers/TrainerRole")
);
const NewJob = lazy(() =>
  import("./pages/afterAuth/careers/companyRole/NewJob")
);
const EditJob = lazy(() =>
  import("./pages/afterAuth/careers/companyRole/EditJob")
);
const CourseEarnings = lazy(() =>
  import("./pages/afterAuth/roiReports/CourseEarnings")
);
const WebinarExpenses = lazy(() =>
  import("./pages/afterAuth/roiReports/WebinarExpenses")
);
const CertificationEarnings = lazy(() =>
  import("./pages/afterAuth/roiReports/CertificationEarnings")
);
const BatchROI = lazy(() => import("./pages/afterAuth/roiReports/BatchROI"));
import SessionDetails from "./components/batch/session-management/SessionDetails";
import QuizForm from "./components/batch/session-management/quiz-form/QuizForm";
import { getUserDetails } from "./utils/services/userLogin/loginService";
import { formatAndStorePermission } from "./utils/functions/common";
const Offers = lazy(() => import("./pages/afterAuth/offers/Offers"));
const OfferDetails = lazy(() =>
  import("./pages/afterAuth/offers/OfferDetails/OfferDetails")
);
const FeedbackQuestions = lazy(() =>
  import("./pages/afterAuth/courses/feedback-question/FeedbackQuestions")
);

const BlogCategories = lazy(() =>
  import("./pages/afterAuth/blogMore/BlogCategories")
);
const SelfBatch = lazy(() =>
  import("./pages/afterAuth/batch/batchSection/SelfBatch")
);

export const allRoutes = [
  {
    path: "/login",
    element: <LoginPvt Component={Login} />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/",
    element: <PrivateRoute Component={Layout} />,
    children: [
      {
        path: "/dashboard",
        element: <PrivateRoute Component={Dashboard} />,
        module: "Dashboard",
      },
      {
        path: "/notifications",
        element: <NotificationsPage />,
        module: "Notifications",
      },
      {
        path: "user",
        module: "User Management",
        children: [
          {
            path: "students",
            element: <Students />,
          },
          {
            path: "trainers",
            element: <Trainers />,
          },
          {
            path: "sub-admins",
            element: <SubAdmins />,
          },
          {
            path: "manage-permissions",
            element: <ManagePermissions />,
          },
          {
            path: "trainers/trainer-edit/:trainerId",
            element: <TrainerForm />,
          },
          {
            path: "trainers/trainer-view/:trainerId/:page",
            element: <TrainerForm />,
          },
          {
            path: "trainers/trainer-edit/:trainerId",
            element: <TrainerForm />,
          },
        ],
        edit: [
          {
            path: "trainers/add-trainer",
            element: <TrainerForm />,
          },
        ],
      },
      {
        path: "/courses",
        module: "Courses",
        children: [
          {
            path: "",
            element: <Courses />,
          },
          {
            path: "view/:courseName/:v",
            element: <AddCourses />,
          },
          {
            path: "enrolled-students",
            element: <EnrolledStudents />,
          },
          {
            path: "course-categories",
            element: <CourseCategories />,
          },
          {
            path: "add-coursesCategory",
            element: <AddCourseCategories />,
          },
          {
            path: "feedback-questions",
            element: <FeedbackQuestions />,
          },
        ],
        edit: [
          {
            path: "add-courses",
            element: <AddCourses />,
          },
          {
            path: "edit/:courseName",
            element: <AddCourses />,
          },
          {
            path: "edit/:courseName/:v",
            element: <AddCourses />,
          },
        ],
      },
      {
        path: "/batch",
        module: "Batch",
        children: [
          {
            path: "",
            element: <CourseList />,
          },
          {
            path: "batchesoverview/add-batch/:value",
            element: <Batch />,
          },
          {
            path: "batchesoverview/add-self-batch/:value",
            element: <SelfBatch />,
          },
          {
            path: "batchesoverview/:courseId/:courseName",
            element: <BatchesOverview />,
          },
          {
            path: "session-detail",
            element: <SessionDetails />,
          },
          {
            path: "quiz-form",
            element: <QuizForm />,
          },
        ],
        edit: [
          {
            path: "batchesoverview/add-batch",
            element: <Batch />,
          },
          {
            path: "batchesoverview/add-self-batch",
            element: <SelfBatch />,
          },
        ],
      },
      {
        path: "/webinar",
        module: "Webinars",
        children: [
          {
            path: "",
            element: <Webinar />,
          },
          {
            path: "view/:id/:tab",
            element: <AddWebinar />,
          },
        ],
        edit: [
          {
            path: "edit",
            element: <AddWebinar />,
          },
          {
            path: "edit/:id",
            element: <AddWebinar />,
          },
          {
            path: "add-webinar",
            element: <AddWebinar />,
          },
        ],
      },
      {
        path: "/blog",
        module: "Blogs & More",
        children: [
          {
            path: "",
            element: <Blog />,
          },
          {
            path: "edit/:blogsname",
            element: <AddBlog />,
          },
          {
            path: "edit/:blogsname/:v",
            element: <AddBlog />,
          },
          {
            path: "blog-categories",
            element: <BlogCategories />,
          },
        ],
        edit: [
          {
            path: "add-blog",
            element: <AddBlog />,
          },
          {
            path: "preview",
            element: <PreviewBlog />,
          },
        ],
      },
      {
        path: "/mock-test",
        module: "Blogs & More",
        children: [
          {
            path: "",
            element: <MockTestOverView />,
          },
          {
            path: "view-mock-test/:id",
            element: <NewMockTest />,
          },
          {
            path: "view-mock-test/:id/:page",
            element: <NewMockTest />,
          },
        ],
        edit: [
          {
            path: "new-mock-test",
            element: <NewMockTest />,
          },
          {
            path: "edit-mock-test/:id",
            element: <NewMockTest />,
          },
        ],
      },
      {
        path: "/calendar",
        element: <Calender />,
        module: "Calendar",
      },

      {
        path: "query",
        // module: "Query & Announcement",
        module: "Announcement",
        children: [
          {
            path: "announcement",
            element: <Announcement />,
          },
        ],
      },
      {
        path: "/careers",
        module: "Careers",
        children: [
          {
            path: "company-role",
            element: <CompanyRole />,
          },
          {
            path: "trainer",
            element: <TrainerRole />,
          },
          {
            path: "manage-job/detail",
            element: <EditJob />,
          },
        ],
        edit: [
          {
            path: "newjob",
            element: <NewJob />,
          },
        ],
      },
      {
        path: "/roi",
        module: "ROI & Reports",
        children: [
          {
            path: "",
            // element: <Roi />,
            element: <BatchROI />,
          },
          {
            path: "paymentReport",
            element: <PaymentReport />,
          },
          {
            path: "course_earnings",
            element: <CourseEarnings />,
          },
          {
            path: "webinar_expenses",
            element: <WebinarExpenses />,
          },
          {
            path: "certification_earnings",
            element: <CertificationEarnings />,
          },
          // {
          //   path: "batch_roi/:courseName",
          //   element: <BatchROI />,
          // },
        ],
      },
      {
        path: "/offers",
        module: "Referral & Offers",
        children: [
          {
            path: "",
            element: <Offers />,
          },
          {
            path: ":offerId/:offerName",
            element: <OfferDetails />,
          },
        ],
      },
    ],
  },
];

function App() {
  const [allowedRoutes, setAllowedRoutes] = useState(allRoutes);
  const [accessibleModules, setAccessibleModules] = useState([]);
  const [role, setRole] = useState("");

  const url = window.location.href;
  const tokenParam = new URLSearchParams(new URL(url).search).get("token");

  const fetchUserDetails = async () => {
    const { payload, error } = await getUserDetails();
    if (payload) {
      const name = payload?.name;
      localStorage.setItem("name", name);
      localStorage.setItem("user", JSON.stringify(payload));
      formatAndStorePermission();
      setRole(payload?.role);
    }
  };

  if (tokenParam) {
    localStorage.setItem("token", tokenParam);
    fetchUserDetails();
  }
  // useEffect(() => {
  //   fetchUserDetails();
  // }, [token]);

  return (
    <>
      <RouteContext.Provider
        value={{
          allowedRoutes,
          accessibleModules,
          role,
          setRole,
          setAllowedRoutes,
          setAccessibleModules,
        }}
      >
        <AppRoutes />
        {/* <RouterProvider router={route} /> */}
      </RouteContext.Provider>
      <ToastContainer />
    </>
  );
}
export default App;
